import "./define_page.css";

function DefinePage() {
  const visit_explain: string = `일상생활에 도움이 필요로 하시는 어르신께 신체활동 및 가사활동, 정서지원 등
일상생활에 도움을 주고자 전문교육을 받은 요양사가 가정에 방문하여 서비스를 제공하는 것입니다.`;

  const family_explain: string = `서비스 이용자의 가족이 직접 케어(신체활동 지원만 가능)하는 방문요양 서비스입니다.
가족요양사가 타 직종에서 월 160시간 이상 근무하시는 분은 가족요양 서비스를 제공할 수 없습니다.

가족요양 서비스 가능 시간 1일 60분 기준으로 월 20회 서비스 제공 가능합니다.
단, 다음과 같은 조건에 해당하는 분들은 1일 90분 기준으로 한 달에 30회 서비스 제공 가능합니다.
1. 65세 이상인 가족요양사가 그 배우자에게 서비스를 제공할 경우
2. 이용자가 치매로 인한 폭력성, 망상, 성적 행동 등 특별한 사유가 있는 경우`;

  return (
    <div className="define_page">
      <div className="define_container">
        <div className="explain_container">
          <div className="term">방문요양이란</div>
          <div>{visit_explain}</div>
        </div>
        <div className="explain_container">
          <div className="term">가족요양이란</div>
          <div>{family_explain}</div>
        </div>
      </div>
    </div>
  );
}

export default DefinePage;
